export function toEpoch(value: string | number | Date): number {
  if (typeof value === 'number') return value;
  if (value instanceof Date) return value.getTime();
  const num = Number(value);
  if (!Number.isNaN(num)) return num;
  const p = Date.parse(value);
  return Number.isNaN(p) ? Date.now() : p;
}

export function fromEpoch(epochMs: number): Date {
  return new Date(epochMs);
}

export function localDateToIso(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function isoToDayMonthYear(iso: string): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return '';
  const [year, month, day] = iso.split('-');
  return `${day}/${month}/${year}`;
}

export function dayMonthYearToIso(display: string): string | null {
  const match = display.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!match) return null;

  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;

  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }

  return localDateToIso(date);
}

export function formatDate(epochMs: number, locale?: string, opts?: Intl.DateTimeFormatOptions): string {
  return new Date(epochMs).toLocaleDateString(locale, opts);
}

export function formatDateTime(epochMs: number, locale?: string, opts?: Intl.DateTimeFormatOptions): string {
  return new Date(epochMs).toLocaleString(locale, opts);
}

